var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", { staticClass: "login-box-msg" }, [
      _vm._v(
        "\n        Please enter a new password and confirm it to reset.\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { role: "form", method: "post" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "input-group mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.password1,
                expression: "form.password1",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.errors["password1"] },
            attrs: { type: "password", placeholder: "Enter New Password" },
            domProps: { value: _vm.form.password1 },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "password1", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm.errors["password1"]
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.errors["password1"]) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.password2,
                expression: "form.password2",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.errors["password2"] },
            attrs: { type: "password", placeholder: "Confirm New Password" },
            domProps: { value: _vm.form.password2 },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "password2", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm.errors["password2"]
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.errors["password2"]) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm._m(2),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c("div", { staticClass: "input-group-text" }, [
        _c("span", { staticClass: "fas fa-lock" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c("div", { staticClass: "input-group-text" }, [
        _c("span", { staticClass: "fas fa-lock" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-block sgp-btn-default",
            attrs: { type: "submit" },
          },
          [_vm._v("\n                    Reset Password\n                ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }